module.exports = __webpack_public_path__ + "static/media/5-1.8e2bfd10.webp";